import axios from "axios";
import i18n from "@/locales/i18n";

const API_URL = "https://prokuroriaapi.cmdsoftwares.com/api/v1/";

//const API_URL="https://localhost:7131/api/v1/"



import { getWebPagesId } from "@/utils/webPage";

class AutoretService {
  async getAutoret(autoret) {
    const webPage = getWebPagesId();

    const requestBody = {
      prokuroriaId: webPage,
      categoryId: autoret.categoryId,
      positionId: autoret.positionId,
      language: i18n.global.locale || "AL",
    };

    return await axios
      .post(`${API_URL}dashboard/author/details`, requestBody)
      .then((response) => response.data)
      .catch((error) => {
        console.error("Error fetching data:", error);

        throw error;
      });
  }
}

export default new AutoretService();
